<script lang="ts">
  import { snapScrollPosition } from '$lib/actions/snap-scroll-position';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import SliderButton from './ui/slider-button.svelte';
  import { drawer } from '$lib/stores/drawer';
  import type { Look } from './look.svelte';
  import LookContent from './look-content.svelte';
  import Drawer from './drawer.svelte';
  import { cn } from '$lib/utils';

  export let allLooks: Look[];
  export let drawerId: string;

  // Carousel
  let carousel: HTMLElement;
  let index = 0;

  const handleCarousel = (
    to: 'left' | 'right' | number,
    behavior: 'instant' | 'smooth' = $reducedMotion ? 'instant' : 'smooth'
  ) => {
    if (to === 'left' && index !== null) {
      carousel.scrollTo({
        left: carousel.clientWidth * (index - 1),
        behavior
      });
    } else if (to === 'right' && index !== null) {
      carousel.scrollTo({
        left: carousel.clientWidth * (index + 1),
        behavior
      });
    } else if (typeof to === 'number') {
      carousel.scrollTo({
        left: carousel.clientWidth * to,
        behavior
      });
    }
  };

  $: if (
    carousel &&
    $drawer.meta?.initialIndex != null &&
    typeof $drawer.meta?.initialIndex === 'number'
  ) {
    index = $drawer.meta?.initialIndex;
    handleCarousel($drawer.meta?.initialIndex, 'instant');
  }
</script>

<!-- Drawer -->
<Drawer
  id={drawerId}
  title={'Look'}
  desktopAsideClass={cn('aspect-[0.56] overflow-hidden', 'w-auto max-w-none')}
>
  <div class="flex h-full flex-col">
    <div
      class="flex h-full w-full snap-x snap-mandatory overflow-x-auto hide-scrollbar motion-reduce:transition-none"
      bind:this={carousel}
      use:snapScrollPosition={(i) => (index = i)}
    >
      {#each allLooks as look}
        <div class="relative flex-1 overflow-hidden shrink-0 min-w-full snap-center snap-always">
          <LookContent {look} variant="drawer" />
        </div>
      {/each}
    </div>

    <div class="items-center justify-between bg-background p-4 flex">
      <SliderButton
        variant="ghost"
        icon="chevron-left-bold"
        ariaLabel="Slider Button Left"
        disabled={index === 0}
        on:click={() => handleCarousel('left')}
      />

      <div class="text-sm lining-nums tabular-nums text-primary/80">
        <span>Look</span>
        <span>{index + 1} / {allLooks.length}</span>
      </div>

      <SliderButton
        variant="ghost"
        icon="chevron-right-bold"
        ariaLabel="Slider Button Right"
        disabled={index === allLooks.length - 1}
        on:click={() => handleCarousel('right')}
      />
    </div>
  </div>
</Drawer>
